import React, {useEffect, useState} from 'react';
import {NiudSteps, RouterSelfInstallSteps} from '../Assets/variables';
import Stage5SVG from '../Assets/SVG/Stage5';
const LoadingScreen = (props) => {
  const secondaryColor = '#D9D9DA';
  const primaryColor = 'var(--theme-primary, #9631ff)';

  const [primaryLoaderColor, setPrimaryLoaderColor] = useState(primaryColor);
  const [secondaryLoaderColor, setSecondaryLoaderColor] = useState(secondaryColor);

  let completedPercentage = 30;
  switch (props.niudStep) {
    case NiudSteps.UPDATESETTINGS:
      completedPercentage = 50;
      break;
    case NiudSteps.CONFIGURING:
      completedPercentage = 70;
      break;
    case NiudSteps.ALMOSTFINISH:
      completedPercentage = 90;
      break;
  }
  const percentLeft = 100 - completedPercentage;

  const renderTitle = () => {
    switch (props.niudStep) {
      case NiudSteps.UPDATESETTINGS:
        return <>הניוד הושלם, מעדכנים הגדרות </>;
      case NiudSteps.ALMOSTFINISH:
        return <>עוד רגע שם!</>;
      case NiudSteps.CONFIGURING:
        return <>ההגדרות נשמרו, כמעט סיימנו! </>;
      default:
        return <>הניוד התחיל </>;
    }
  };

  return (
    <>
      <div className='svgContainerHead'>
        <Stage5SVG />{' '}
      </div>
      <div className='headBox'>
        <p className='heading'>{renderTitle()}</p>
        {props.niudStep == NiudSteps.NIUD && (
          <p className='subHeading'>
            חשוב לא לסגור את המדריך
            <br />
            אבל אפשר לגלוש באפליקציות חיצוניות
          </p>
        )}
      </div>
      <div>
        <div className='completedTip'>הושלמו {completedPercentage}%</div>
        <div className='progressBar'>
          <svg xmlns='http://www.w3.org/2000/svg' width='179' height='6' viewBox='0 0 179 6' fill='none'>
            <path d='M176 3L3 2.99998' stroke='url(#paint0_linear_11157_2314)' strokeWidth='6' strokeLinecap='round' />
            <defs>
              <linearGradient id='paint0_linear_11157_2314' x1='3' y1='2.49998' x2='176' y2='2.5' gradientUnits='userSpaceOnUse'>
                <stop offset={`.${percentLeft}`} stopColor={completedPercentage == '100' ? primaryColor : secondaryColor} />
                <stop offset={`.${percentLeft}0006`} stopColor={completedPercentage == '0' ? secondaryColor : primaryColor} />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </>
  );
};

export default LoadingScreen;
